'use strict';
module.exports = Odigeo.Model.extend({
    defaults: {
        index: 0,
        numPassenger: 0,
        name: '',
        defaultName: '',
        firstLastName: '',
        shortName: '',
        defaultShortName: 'P',
        travellerType: '',
    },
});
